<template>
    <q-dialog ref="dialog" @hide="onDialogHide" persistent>
        <q-card class="q-dialog-plugin" style="width: 45vw; max-width: 90vw;">
            <q-toolbar class="bg-primary text-white">
                <q-toolbar-title>{{ title }}</q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup></q-btn>
            </q-toolbar>

            <q-form ref="modelForm">
                <q-card-section>
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12">
                                <q-table row-key="Id" :data="BundleItems"
                                         :filter="modelMetadata.BundleItems.filter"
                                         :columns="modelMetadata.BundleItems.columns"
                                         :visible-columns="modelMetadata.BundleItems.columnsVisible"
                                         :pagination="modelMetadata.BundleItems.pagination"
                                         hide-pagination
                                         hide-header dense round flat
                                         style="max-height: 372px;">
                                    <template v-slot:top-right>
                                        <div v-if="true">
                                            <q-input class="q-mr-md" v-model="modelMetadata.BundleItems.filter"
                                                     placeholder="Search" debounce="300" clearable clear-icon="close" dense flat>
                                                <template v-slot:prepend>
                                                    <q-icon name="search"></q-icon>
                                                </template>
                                            </q-input>
                                        </div>
                                        <div class="q-gutter-xs">
                                            <q-btn icon="add" size="sm"
                                                   dense round flat
                                                   color="primary"
                                                   @click="onCreateActionClick()">

                                            </q-btn>
                                        </div>
                                    </template>
                                    <template v-slot:body-cell-Actions="props">
                                        <q-td :props="props" auto-width>
                                            <div class="q-gutter-xs">
                                                <q-btn icon="edit" size="sm"
                                                       dense round flat
                                                       color="primary"
                                                       @click="onEditActionClick(props.key, props.rowIndex, props.row)">
                                                </q-btn>
                                                <q-btn icon="delete" size="sm"
                                                       dense round flat
                                                       color="primary"
                                                       @click="onRemoveItemActionClick(props.key, props.rowIndex, props.row)">
                                                </q-btn>
                                            </div>
                                        </q-td>
                                    </template>
                                </q-table>
                            </div>

                        </div>
                    </div>
                </q-card-section>

                <q-card-actions align="right" class="bg-grey-2" v-if="editMode === true">
                    <q-btn color="primary" :label="actionLabel" @click="onOkClick"></q-btn>
                    <q-btn color="white" text-color="black" label="Cancel" @click="onCancelClick"></q-btn>
                </q-card-actions>
                <q-card-actions align="right" class="bg-grey-2" v-if="editMode === false">
                    <q-btn color="white" text-color="black" label="Close" @click="onCancelClick"></q-btn>
                </q-card-actions>
            </q-form>

            <q-inner-loading :showing="loading">
                <q-spinner-gears size="50px" color="primary"></q-spinner-gears>
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<script>
    export { default } from './sku-map-bundle-items-edit-dialog-screen.js'
</script>